import { render } from "./OrderUpdate.vue?vue&type=template&id=ddf2cc4c&scoped=true"
import script from "./OrderUpdate.vue?vue&type=script&lang=js"
export * from "./OrderUpdate.vue?vue&type=script&lang=js"

import "./OrderUpdate.vue?vue&type=style&index=0&id=ddf2cc4c&scoped=true&lang=css"

import exportComponent from "/Users/andresrivas/NoSincronizar/Vue/Swift Fulfillment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf2cc4c"]])

export default __exports__